import { DOCUMENT } from '@angular/common';
import type { OnDestroy } from '@angular/core';
import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from '@angular/core';
import {
    DealerFeature,
    injectScript,
    injectStyle,
    ShopPageFeature,
    type InjectedScript,
    type InjectionOptions,
} from '@hyundai/ng-common-lib';
import { EditableDirective } from '@hyundai/ng-edit-lib';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-shop-page',
    standalone: true,
    imports: [EditableDirective],
    templateUrl: './shop-page.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./shop-page.component.scss'],
})
export class ShopPageComponent implements OnDestroy {
    protected readonly store = inject(Store);
    protected readonly document = inject(DOCUMENT);

    protected dealerLocationHeadline = this.store.selectSignal(DealerFeature.state.selectDealerLocationHeadline);
    protected shopPageContent = this.store.selectSignal(ShopPageFeature.state.selectLoadedContent);
    dealer = this.store.selectSignal(DealerFeature.state.selectLoadedDealer);

    dummyPartnerIds: string[] = ['1001', '1338', '1339'];

    scripts: InjectedScript[] = [];

    shopIdentifier = computed(
        () => `hyundai_${this.dummyPartnerIds.includes(this.dealer().id) ? '2452' : this.dealer().id}`,
    );
    constructor() {
        this.loadScripts();
    }

    async loadScripts() {
        const options: InjectionOptions = {
            reuse: true,
        };
        this.scripts = await Promise.all([
            injectStyle('https://zubehoer-navigator.de/static/css/main.css', options),
            injectScript('https://zubehoer-navigator.de/static/js/main.js', options),
        ]);
    }

    ngOnDestroy(): void {
        const eles = Array.from(this.document.querySelectorAll('.ReactModalPortal'));
        for (const el of eles) {
            el.remove();
        }
        for (const script of this.scripts) {
            if (script) {
                script.remove();
            }
        }
    }
}
